// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1__e541c9ba31af81b25f31","cls2":"AuthorHeader-cls2__de4e2e9df7c1f1853bd0 AuthorHeader-cls1__e541c9ba31af81b25f31"};